export const formValidationErrorType = {
  valid: 1,
  empty: 2,
  wrong: 3,
};

export const statusList = [
  { key: 0, value: 'active', name: 'Active' },
  { key: 1, value: 'inactive', name: 'In-Active' },
];

export const statusCodes = {
  forbidden: 403,
  conflict: 409,
};
